import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import html2canvas from "html2canvas";

const StatsCardModalDownload = (props) => {
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  const brandingDetails = JSON.parse(localStorage.getItem("branding"));
  const modalContentRef = useRef(null);
  const captureImage = useCallback(() => {
    const modalContent = document.getElementById("playermoreinfo");

    if (modalContent) {
      html2canvas(modalContent, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-Top 10 Players`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  }, []);

  const handleModalEntered = useCallback(() => {
    const timeout = setTimeout(() => {
      captureImage();
      props.handleRankModalClose();
    }, 2000);
    return () => clearTimeout(timeout); // Cleanup the timeout
  }, [captureImage]);

  return (
    <Modal
      show={props.showRankModal}
      onHide={props.handleRankModalClose}
      size="lg"
      id="playermoreinfo"
      onEntered={handleModalEntered}
    >
      <div ref={modalContentRef}>
        <div className="player_star_info">
          <div className="player_star_pic">
            <Link
              className="player_profile_url"
              onClick={(e) => e.preventDefault()}
            >
              <figure className="player_profile_url">
                {clubDetails && (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                    alt="img"
                  />
                )}
                {!clubDetails && (
                  <img src={`../images/club-logo.png`} alt="img" />
                )}
              </figure>
            </Link>
            <div className="player_description">
              <h3 className="breakWord">
                Top 10 {props.statsRecordType == "sum_fp" && "Fantasy Points"}
                {props.statsRecordType == "sum_go" && "Runs"}
                {props.statsRecordType == "sum_gks" && "GKS"}
                {props.statsRecordType == "sum_og" && "OG"}
                {props.statsRecordType == "sum_ast" && "AST"}
                {props.statsRecordType == "sum_pi" && "PI"}
                {props.statsRecordType == "sum_tw" && "TW"}
                {props.statsRecordType == "sum_ps" && "PS"}
                {props.statsRecordType == "sum_pm" && "PM"}
                {props.statsRecordType == "sum_gcd" && "GCD"}
                {props.statsRecordType == "sum_ycd" && "YCD"}
                {props.statsRecordType == "sum_rcd" && "RCD"}
                {props.statsRecordType == "sum_cst" && "CST"}
                {props.statsRecordType == "sum_p60" && "P<60"}
                {props.statsRecordType == "sum_p60plus" && "P60+"}
                {props.statsRecordType == "avg_pts" && "Average-Points"}
                {props.statsRecordType == "pcap" && "Pick-CAP%"}
                {props.statsRecordType == "pvcap" && "Pick-VCAP%"}
              </h3>
              <div className="player_game_name">{clubDetails?.game_name}</div>
              <div className="player_game_name">
                Type:{" "}
                {props.roundId ? <> Round {props.roundId}</> : " Overall "}{" "}
              </div>
              <div className="player_game_name">
                Gameviews: {props.gameInfoBlockData?.gameViews}
              </div>
            </div>
          </div>
          <div className="club_logo">
            <figure>
              {!props.playerSponsorLogo && brandingDetails && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}branding/${brandingDetails.logo}`}
                  alt="img"
                />
              )}
              {!brandingDetails && (
                <img src={`../images/small-brand-logo.jpg`} alt="img" />
              )}
            </figure>
          </div>
        </div>

        <div className="player-performance1">
          <ul>
            {props.topTenRecord &&
              props.topTenRecord.map((item, key) => (
                <>
                  <li key={item?.id}>
                    <div className="performancebox1">
                      <div className="playerprofilerank">
                        {key + 1}
                        <figure>
                          {item?.is_avatar === 1 ? (
                            <img
                              src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`}
                              alt="img"
                            />
                          ) : (
                            <img
                              src={`${process.env.REACT_APP_UPLOAD_URL}player/${item.image}`}
                              alt="img"
                            />
                          )}
                        </figure>
                        {item?.full_name}
                      </div>
                      <strong>
                        {" "}
                        {props.statsRecordType == "sum_fp" && item["sum_fp"]}
                        {props.statsRecordType == "sum_rs" && item["sum_rs"]}
                        {props.statsRecordType == "sum_fours" &&
                          item["sum_fours"]}
                        {props.statsRecordType == "sum_sixes" &&
                          item["sum_sixes"]}
                        {props.statsRecordType == "sum_wks" && item["sum_wks"]}
                        {props.statsRecordType == "sum_mdns" &&
                          item["sum_mdns"]}
                        {props.statsRecordType == "sum_hattrick" &&
                          item["sum_hattrick"]}
                        {props.statsRecordType == "sum_cs" && "sum_cs"}
                        {props.statsRecordType == "sum_cwk" && item["sum_cwk"]}
                        {props.statsRecordType == "sum_sts" && item["sum_sts"]}
                        {props.statsRecordType == "sum_overs" &&
                          item["sum_overs"]}
                        {props.statsRecordType == "avg_pts" && item["avg_pts"]}
                        {props.statsRecordType == "pcap" && item["pcap"]}
                        {props.statsRecordType == "pvcap" && item["pvcap"]}
                      </strong>
                    </div>
                  </li>
                </>
              ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default StatsCardModalDownload;
